import { lazyLoad } from "utils/loadable";

export const ViewInternshipDetails = lazyLoad(
  () => import("./index"),
  (module) => module.InternshipDetails
);